import * as models from '../../domain/models';
import * as actions from '../actions/region-detail';

import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  item: models.Region;
  pristine: boolean;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  pristine: true,
  item: null,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.SAVE:
    case actions.LOAD: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }

    case actions.SAVE_SUCCESS:
    case actions.LOAD_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        pristine: true,
        item: _.cloneDeep(action.payload.item),
      };
    }

    case actions.SAVE_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        pristine: false,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...initialState,
        isLoaded: true,
      };
    }

    case actions.UPDATE: {
      return {
        ...state,
        pristine: false,
        item: _.cloneDeep(action.payload.item),
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItem = (state: State) => state.item;
export const getPristine = (state: State) => state.pristine;
